// extracted by mini-css-extract-plugin
export default {"container":"EmailShare_container__mthJ5","shareEmailBtn":"EmailShare_shareEmailBtn__Tnav8","emailSvg":"EmailShare_emailSvg__NH79U"};